// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  font-size: 1.2rem;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb {
    font-size: 1rem;
  }
}
:host .breadcrumb li a .icon,
:host .breadcrumb li .static .icon {
  font-size: 1rem;
  margin-right: 6px;
}
.rtl :host .breadcrumb li a .icon,
.rtl :host .breadcrumb li .static .icon {
  margin-left: 6px;
  margin-right: 0;
}
:host .breadcrumb li .separator {
  color: rgba(0, 0, 0, 0.4);
  margin: 0 0.7857143rem;
}
:host .breadcrumb.custom-1 {
  margin: -2px -7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 {
    margin-left: -2px;
    margin-right: -2px;
  }
}
:host .breadcrumb.custom-1 li {
  margin: 2px 7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li {
    margin-left: 2px;
    margin-right: 2px;
  }
}
:host .breadcrumb.custom-1 li a,
:host .breadcrumb.custom-1 li .static {
  background: #5dade0;
  border-color: #5dade0;
  color: #fff;
  display: inline-block;
  height: 36px;
  padding: 5px 1.5714286rem;
  position: relative;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  vertical-align: top;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li a,
  :host .breadcrumb.custom-1 li .static {
    height: auto;
    padding: 2px 0.7857143rem;
  }
}
:host .breadcrumb.custom-1 li a:before, :host .breadcrumb.custom-1 li a:after,
:host .breadcrumb.custom-1 li .static:before,
:host .breadcrumb.custom-1 li .static:after {
  border-style: solid;
  border-color: transparent;
  content: "";
  display: block;
  height: 0px;
  position: absolute;
  top: 0px;
  transition: border-color 0.2s ease-in-out;
  width: 0px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-1 li a:before, :host .breadcrumb.custom-1 li a:after,
  :host .breadcrumb.custom-1 li .static:before,
  :host .breadcrumb.custom-1 li .static:after {
    display: none;
  }
  .rtl :host .breadcrumb.custom-1 li a:before, .rtl :host .breadcrumb.custom-1 li a:after,
  .rtl :host .breadcrumb.custom-1 li .static:before,
  .rtl :host .breadcrumb.custom-1 li .static:after {
    display: none !important;
  }
}
:host .breadcrumb.custom-1 li a:before,
:host .breadcrumb.custom-1 li .static:before {
  border-width: 36px 10px 0 0;
  border-right-color: inherit;
  left: -10px;
}
:host .breadcrumb.custom-1 li a:after,
:host .breadcrumb.custom-1 li .static:after {
  border-width: 0 0 36px 10px;
  border-left-color: inherit;
  right: -10px;
}
:host .breadcrumb.custom-1 li a:hover {
  background: #fff;
  border-color: #fff;
  color: #5dade0;
}
:host .breadcrumb.custom-1 li .static {
  opacity: 0.6;
}
:host .breadcrumb.custom-1 li .separator {
  display: none;
}
:host .breadcrumb.custom-1 li:first-child a:before,
:host .breadcrumb.custom-1 li:first-child .static:before {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:first-child a:before,
.rtl :host .breadcrumb.custom-1 li:first-child .static:before {
  display: block;
}
.rtl :host .breadcrumb.custom-1 li:first-child a:after,
.rtl :host .breadcrumb.custom-1 li:first-child .static:after {
  display: none;
}
:host .breadcrumb.custom-1 li:last-child a:after,
:host .breadcrumb.custom-1 li:last-child .static:after {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:last-child a:before,
.rtl :host .breadcrumb.custom-1 li:last-child .static:before {
  display: none;
}
.rtl :host .breadcrumb.custom-1 li:last-child a:after,
.rtl :host .breadcrumb.custom-1 li:last-child .static:after {
  display: block;
}
:host .breadcrumb.custom-2 {
  margin: -2px -7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 {
    margin-left: -2px;
    margin-right: -2px;
  }
}
:host .breadcrumb.custom-2 li {
  margin: 2px 7px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li {
    margin-left: 2px;
    margin-right: 2px;
  }
}
:host .breadcrumb.custom-2 li a,
:host .breadcrumb.custom-2 li .static {
  background: #5dade0;
  border-color: #5dade0;
  color: #fff;
  display: inline-block;
  height: 36px;
  padding: 5px 1.5714286rem;
  position: relative;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  vertical-align: top;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li a,
  :host .breadcrumb.custom-2 li .static {
    height: auto;
    padding: 2px 0.7857143rem;
  }
}
:host .breadcrumb.custom-2 li a:before, :host .breadcrumb.custom-2 li a:after,
:host .breadcrumb.custom-2 li .static:before,
:host .breadcrumb.custom-2 li .static:after {
  border-style: solid;
  border-color: transparent;
  content: "";
  display: block;
  height: 0px;
  position: absolute;
  top: 0px;
  transition: border-color 0.2s ease-in-out;
  width: 0px;
}
@media screen and (max-width: 767px) {
  :host .breadcrumb.custom-2 li a:before, :host .breadcrumb.custom-2 li a:after,
  :host .breadcrumb.custom-2 li .static:before,
  :host .breadcrumb.custom-2 li .static:after {
    display: none;
  }
}
:host .breadcrumb.custom-2 li a:before,
:host .breadcrumb.custom-2 li .static:before {
  border-width: 18px 0 18px 10px;
  border-top-color: inherit;
  border-bottom-color: inherit;
  left: -10px;
}
.rtl :host .breadcrumb.custom-2 li a:before,
.rtl :host .breadcrumb.custom-2 li .static:before {
  border-style: solid;
  border-color: transparent;
  border-width: 18px 0 18px 10px;
  border-left-color: inherit;
  left: auto;
  right: -10px;
}
:host .breadcrumb.custom-2 li a:after,
:host .breadcrumb.custom-2 li .static:after {
  border-width: 18px 0 18px 10px;
  border-left-color: inherit;
  right: -10px;
}
.rtl :host .breadcrumb.custom-2 li a:after,
.rtl :host .breadcrumb.custom-2 li .static:after {
  border-style: solid;
  border-color: transparent;
  border-width: 18px 0 18px 10px;
  border-top-color: inherit;
  border-bottom-color: inherit;
  left: -10px;
  right: auto;
}
:host .breadcrumb.custom-2 li a:hover {
  background: #fff;
  border-color: #fff;
  color: #5dade0;
}
:host .breadcrumb.custom-2 li .static {
  opacity: 0.6;
}
:host .breadcrumb.custom-2 li .separator {
  display: none;
}
:host .breadcrumb.custom-2 li:first-child a:before,
:host .breadcrumb.custom-2 li:first-child .static:before {
  display: none;
}
:host .breadcrumb.custom-2 li:last-child a:after,
:host .breadcrumb.custom-2 li:last-child .static:after {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AADF;AAGE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AADJ;AAEI;EAPF;IAQI,eAAA;EACJ;AACF;AAIQ;;EACE,eAAA;EACA,iBAAA;AADV;AAGU;;EACE,gBAAA;EACA,eAAA;AAAZ;AAIM;EACE,yBAAA;EACA,sBAAA;AAFR;AAKI;EACE,iBAAA;AAHN;AAIM;EAFF;IAGI,iBAAA;IACA,kBAAA;EADN;AACF;AAGM;EACE,eAAA;AADR;AAEQ;EAFF;IAGI,gBAAA;IACA,iBAAA;EACR;AACF;AACQ;;EAEE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,+DACE;EAEF,mBAAA;AADV;AAEU;EAbF;;IAcI,YAAA;IACA,yBAAA;EAEV;AACF;AAAU;;;EAEE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yCAAA;EACA,UAAA;AAGZ;AAFY;EAXF;;;IAYI,aAAA;EAOZ;EALY;;;IACE,wBAAA;EASd;AACF;AANU;;EACE,2BAAA;EACA,2BAAA;EACA,WAAA;AASZ;AAPU;;EACE,2BAAA;EACA,0BAAA;EACA,YAAA;AAUZ;AANU;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAQZ;AALQ;EACE,YAAA;AAOV;AALQ;EACE,aAAA;AAOV;AAFY;;EACE,aAAA;AAKd;AAFc;;EACE,cAAA;AAKhB;AAHc;;EACE,aAAA;AAMhB;AAEY;;EACE,aAAA;AACd;AAEc;;EACE,aAAA;AAChB;AACc;;EACE,cAAA;AAEhB;AAKI;EACE,iBAAA;AAHN;AAIM;EAFF;IAGI,iBAAA;IACA,kBAAA;EADN;AACF;AAGM;EACE,eAAA;AADR;AAEQ;EAFF;IAGI,gBAAA;IACA,iBAAA;EACR;AACF;AACQ;;EAEE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,+DACE;EAEF,mBAAA;AADV;AAEU;EAbF;;IAcI,YAAA;IACA,yBAAA;EAEV;AACF;AAAU;;;EAEE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yCAAA;EACA,UAAA;AAGZ;AAFY;EAXF;;;IAYI,aAAA;EAOZ;AACF;AALU;;EACE,8BAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;AAQZ;AANY;;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,0BAAA;EACA,UAAA;EACA,YAAA;AASd;AANU;;EACE,8BAAA;EACA,0BAAA;EACA,YAAA;AASZ;AAPY;;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;AAUd;AALU;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AAOZ;AAJQ;EACE,YAAA;AAMV;AAJQ;EACE,aAAA;AAMV;AADY;;EACE,aAAA;AAId;AAGY;;EACE,aAAA;AAAd","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n:host {\r\n  display: block;\r\n\r\n  .breadcrumb {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    font-size: 1.2rem;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    @media screen and (max-width: 767px) {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    li {\r\n      a,\r\n      .static {\r\n        .icon {\r\n          font-size: 1rem;\r\n          margin-right: 6px;\r\n\r\n          .rtl & {\r\n            margin-left: 6px;\r\n            margin-right: 0;\r\n          }\r\n        }\r\n      }\r\n      .separator {\r\n        color: rgba(#000,.4);\r\n        margin: 0 $module/2;\r\n      }\r\n    }\r\n    &.custom-1 {\r\n      margin: -2px -7px;\r\n      @media screen and (max-width: 767px) {\r\n        margin-left: -2px;\r\n        margin-right: -2px;\r\n      }\r\n\r\n      li {\r\n        margin: 2px 7px;\r\n        @media screen and (max-width: 767px) {\r\n          margin-left: 2px;\r\n          margin-right: 2px;\r\n        }\r\n\r\n        a,\r\n        .static {\r\n          background: main-color(A100);\r\n          border-color: main-color(A100);\r\n          color: #fff;\r\n          display: inline-block;\r\n          height: 36px;\r\n          padding: 5px $module;\r\n          position: relative;\r\n          transition:\r\n            background .2s $animation,\r\n            color .2s $animation;\r\n          vertical-align: top;\r\n          @media screen and (max-width: 767px) {\r\n            height: auto;\r\n            padding: 2px ($module / 2);\r\n          }\r\n\r\n          &:before,\r\n          &:after {\r\n            border-style: solid;\r\n            border-color: transparent;\r\n            content: '';\r\n            display: block;\r\n            height: 0px;\r\n            position: absolute;\r\n            top: 0px;\r\n            transition: border-color .2s $animation;\r\n            width: 0px;\r\n            @media screen and (max-width: 767px) {\r\n              display: none;\r\n\r\n              .rtl & {\r\n                display: none !important;\r\n              }\r\n            }\r\n          }\r\n          &:before {\r\n            border-width: 36px 10px 0 0;\r\n            border-right-color: inherit;\r\n            left: -10px;\r\n          }\r\n          &:after {\r\n            border-width: 0 0 36px 10px;\r\n            border-left-color: inherit;\r\n            right: -10px;\r\n          }\r\n        }\r\n        a {\r\n          &:hover {\r\n            background: #fff;\r\n            border-color: #fff;\r\n            color: main-color(A100);\r\n          }\r\n        }\r\n        .static {\r\n          opacity: .6;\r\n        }\r\n        .separator {\r\n          display: none;\r\n        }\r\n        &:first-child {\r\n          a,\r\n          .static {\r\n            &:before {\r\n              display: none;\r\n            }\r\n            .rtl & {\r\n              &:before {\r\n                display: block;\r\n              }\r\n              &:after {\r\n                display: none;\r\n              }\r\n            }\r\n          }\r\n        }\r\n        &:last-child {\r\n          a,\r\n          .static {\r\n            &:after {\r\n              display: none;\r\n            }\r\n            .rtl & {\r\n              &:before {\r\n                display: none;\r\n              }\r\n              &:after {\r\n                display: block;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &.custom-2 {\r\n      margin: -2px -7px;\r\n      @media screen and (max-width: 767px) {\r\n        margin-left: -2px;\r\n        margin-right: -2px;\r\n      }\r\n\r\n      li {\r\n        margin: 2px 7px;\r\n        @media screen and (max-width: 767px) {\r\n          margin-left: 2px;\r\n          margin-right: 2px;\r\n        }\r\n\r\n        a,\r\n        .static {\r\n          background: main-color(A100);\r\n          border-color: main-color(A100);\r\n          color: #fff;\r\n          display: inline-block;\r\n          height: 36px;\r\n          padding: 5px $module;\r\n          position: relative;\r\n          transition:\r\n            background .2s $animation,\r\n            color .2s $animation;\r\n          vertical-align: top;\r\n          @media screen and (max-width: 767px) {\r\n            height: auto;\r\n            padding: 2px ($module / 2);\r\n          }\r\n\r\n          &:before,\r\n          &:after {\r\n            border-style: solid;\r\n            border-color: transparent;\r\n            content: '';\r\n            display: block;\r\n            height: 0px;\r\n            position: absolute;\r\n            top: 0px;\r\n            transition: border-color .2s $animation;\r\n            width: 0px;\r\n            @media screen and (max-width: 767px) {\r\n              display: none;\r\n            }\r\n          }\r\n          &:before {\r\n            border-width: 18px 0 18px 10px;\r\n            border-top-color: inherit;\r\n            border-bottom-color: inherit;\r\n            left: -10px;\r\n\r\n            .rtl & {\r\n              border-style: solid;\r\n              border-color: transparent;\r\n              border-width: 18px 0 18px 10px;\r\n              border-left-color: inherit;\r\n              left: auto;\r\n              right: -10px;\r\n            }\r\n          }\r\n          &:after {\r\n            border-width: 18px 0 18px 10px;\r\n            border-left-color: inherit;\r\n            right: -10px;\r\n\r\n            .rtl & {\r\n              border-style: solid;\r\n              border-color: transparent;\r\n              border-width: 18px 0 18px 10px;\r\n              border-top-color: inherit;\r\n              border-bottom-color: inherit;\r\n              left: -10px;\r\n              right: auto;\r\n            }\r\n          }\r\n        }\r\n        a {\r\n          &:hover {\r\n            background: #fff;\r\n            border-color: #fff;\r\n            color: main-color(A100);\r\n          }\r\n        }\r\n        .static {\r\n          opacity: .6;\r\n        }\r\n        .separator {\r\n          display: none;\r\n        }\r\n        &:first-child {\r\n          a,\r\n          .static {\r\n            &:before {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n        &:last-child {\r\n          a,\r\n          .static {\r\n            &:after {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
